export enum CustomerInventoryTableColumnIdentifiers {
  CustomerName = "customerName",
  CustomerContactName = "customerContactName",
  AltSpid = "altSpid",
  InternalId = "internalId",
  Users = "users",
  Activation = "activation",
  Actions = "actions"
}